import React from "react";

import { Props } from "./types";

function OpenFolderIcon({ className, style }: Props) {
  return (
    <svg className={className} style={style} viewBox="0 0 17.713 12.697">
      <g transform="translate(24193 24003.347)">
        <g transform="translate(-24193 -24042.703)">
          <g transform="translate(0 39.356)">
            <path
              d="M13.155,41.668H8.406a.717.717,0,0,1-.511-.214L6.414,39.894a1.878,1.878,0,0,0-1.337-.538H1.849A1.851,1.851,0,0,0,0,41.2v9a1.851,1.851,0,0,0,1.849,1.849H13.164A1.851,1.851,0,0,0,15,50.2V43.517A1.851,1.851,0,0,0,13.155,41.668Zm.718,8.533a.719.719,0,0,1-.712.721H1.849a.719.719,0,0,1-.718-.718v-9a.72.72,0,0,1,.718-.719H5.11a.713.713,0,0,1,.5.2l1.474,1.554a1.857,1.857,0,0,0,1.327.562h4.749a.719.719,0,0,1,.718.718V50.2Z"
              transform="translate(0 -39.356)"
            />
          </g>
        </g>
        <path
          d="M3.763,0l12.15.027a.65.65,0,0,1,.278.055.35.35,0,0,1,.163.149.363.363,0,0,1,.036.221.689.689,0,0,1-.1.27L14.162,4.176a1.253,1.253,0,0,1-.228.268,1.741,1.741,0,0,1-.65.367,1.223,1.223,0,0,1-.344.055L.819,4.891a.684.684,0,0,1-.285-.054.366.366,0,0,1-.17-.148.361.361,0,0,1-.042-.221A.668.668,0,0,1,.42,4.2L2.522.7A1.242,1.242,0,0,1,2.75.429,1.741,1.741,0,0,1,3.411.056,1.244,1.244,0,0,1,3.763,0Z"
          transform="translate(-24192 -23995.953)"
        />
      </g>
    </svg>
  );
}

export { OpenFolderIcon };
